/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginWithGoogleDto
 */
export interface LoginWithGoogleDto {
    /**
     * 
     * @type {string}
     * @memberof LoginWithGoogleDto
     */
    googleToken: string;
}

/**
 * Check if a given object implements the LoginWithGoogleDto interface.
 */
export function instanceOfLoginWithGoogleDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "googleToken" in value;

    return isInstance;
}

export function LoginWithGoogleDtoFromJSON(json: any): LoginWithGoogleDto {
    return LoginWithGoogleDtoFromJSONTyped(json, false);
}

export function LoginWithGoogleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginWithGoogleDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'googleToken': json['googleToken'],
    };
}

export function LoginWithGoogleDtoToJSON(value?: LoginWithGoogleDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'googleToken': value.googleToken,
    };
}

